export default "__VITE_ASSET__BOp3a4Ac__"